import React, { useEffect } from 'react';
import get from 'lodash/get';
import { useLocation } from 'react-router-dom';
import getContentTermsOfUse from '@kfc-global/react-shared/redux/Actions/TermsOfUseAction';
import getMarketConfigContentCall from '@kfc-global/react-shared/redux/Actions/MarketConfigAction';
import { useSelector, useDispatch } from 'react-redux';
import { StartOrderComponent } from '../../../organisms/StartOrderComponent';
import { Footer } from '../../../organisms/FooterComponent';
import HOME_PAGE_CONTAINER_CONSTANTS from '../../homePageContainer/Constants/homePageContainerConstants';
import { Header } from '../../../organisms/HeaderComponent';
import TermsOfUseContainer from '../../../organisms/TermsOfUse/Container/TermsOfUseContainer';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import {
  getHeaderContentData,
  getHeaderData,
  getFooterData,
  getTermsOfUseData,
  getTernaryValue,
  isCurrentPageRedirectFromRNA,
} from 'common/utilities/utils';
import { getCmsClient } from '../../../common/utilities/cmsClient';
import {
  TERMS_AND_CONDITIONS_URL,
  TERMS_AND_CONDITIONS_TITLE,
} from 'organisms/CouponsLanding/Constants/CouponConstants';
import { ChannelManager } from 'common/manager';
import isEmpty from 'lodash/isEmpty';
import { StructureData } from '../../../organisms/StructureDataComponent';
import { getContentCall } from '@kfc-global/react-shared/redux/Actions/ContentAction';

const TermsOfUseComponent = props => {
  const termsAndConditionsUrlValue = translateWithI18Next(TERMS_AND_CONDITIONS_TITLE);
  const tenantReducer = useSelector(data => data.tenantReducer);
  const dispatch = useDispatch();
  let userParams = useSelector(data => data.appStateReducer.userStatus);

  useEffect(() => {
    dispatch(
      getMarketConfigContentCall({
        object: getCmsClient(),
        contentFull: {
          content_type: 'marketConfig',
          'fields.location': tenantReducer?.country,
          'fields.channel': ChannelManager.channel,
          include: 5,
        },
      }),
    );
    dispatch(
      getContentCall({
        object: getCmsClient(),
        contentFull: {
          content_type: 'landingPage',
          'fields.pageType': 'HomePage',
          'fields.channel': ChannelManager.channel,
          include: '5',
        },
        userParams,
      }),
    );
  }, [dispatch, tenantReducer?.country, userParams]);

  const location = useLocation();

  useEffect(() => {
    //In order to show title in RN App
    if (location.pathname.includes(TERMS_AND_CONDITIONS_URL) && translateWithI18Next(TERMS_AND_CONDITIONS_TITLE)) {
      document.title = termsAndConditionsUrlValue;
    }
  }, [termsAndConditionsUrlValue, location.pathname]);

  /* to call API dynamically [fields.page : 'Terms and Conditions' or 'Terms of Use' ] */

  const hide_nav = isCurrentPageRedirectFromRNA(location, ['/terms-of-use', '/terms-and-conditions']);

  const fieldsPageValue = getTernaryValue(
    location.pathname.includes('terms-of-use'),
    'Terms of Use',
    'Terms and Conditions',
  );

  useEffect(() => {
    dispatch(
      getContentTermsOfUse({
        object: getCmsClient(),
        contentFull: {
          content_type: 'staticLandingPage',
          'fields.page': fieldsPageValue,
          include: '5',
        },
      }),
    );
  }, [dispatch, fieldsPageValue, location.pathname]);

  let segmentedHomePageData = null,
    segmentedMarketingData = null,
    segmentedTermsOfUse = null,
    segmentedFooterData = null;

  const { DISPOSITION } = HOME_PAGE_CONTAINER_CONSTANTS;

  const allReducerData = useSelector(data => {
    return {
      homePageContent: get(data, 'contentReducer.response', null),
      marketPageContent: get(data, 'marketConfigReducer.response', null),
      tenantReducerContent: get(data, 'tenantReducer', null),
      termsOfUseContent: get(data, 'termsOfUseReducer.response', null),
    };
  });
  if (
    allReducerData.marketPageContent &&
    allReducerData.tenantReducerContent &&
    allReducerData.homePageContent &&
    !isEmpty(allReducerData.termsOfUseContent)
  ) {
    segmentedHomePageData = getHeaderContentData(allReducerData.homePageContent);
    const { header = {}, footer = {} } = allReducerData.marketPageContent?.headerData ?? {};
    segmentedMarketingData = getHeaderData(header);
    segmentedFooterData = getFooterData(footer);
    segmentedTermsOfUse = getTermsOfUseData(allReducerData?.termsOfUseContent?.termsResponseData?.items?.[0]?.fields);
  }
  return (
    <>
      {(!isEmpty(segmentedMarketingData) && !hide_nav && (
        <Header
          contentData={segmentedMarketingData}
          tenantReducerData={allReducerData.tenantReducerContent}
          userParams={userParams}
        />
      )) ||
        null}
      {!hide_nav && (
        <StartOrderComponent
          contentData={{
            segmentedHomePageData: segmentedHomePageData?.[DISPOSITION] ?? {},
            contentDispositionData: segmentedHomePageData?.[DISPOSITION] ?? {},
          }}
          userParams={userParams}
        />
      )}
      {!isEmpty(segmentedTermsOfUse) && (
        <>
          {segmentedTermsOfUse?.seoTemplate && <StructureData seoTemplate={segmentedTermsOfUse?.seoTemplate} />}
          <TermsOfUseContainer contentData={segmentedTermsOfUse} />
        </>
      )}
      {(!isEmpty(segmentedFooterData) && !hide_nav && (
        <Footer
          history={props.history}
          contentData={segmentedFooterData}
          tenantReducerData={allReducerData.tenantReducerContent}
        />
      )) ||
        null}
    </>
  );
};

export default TermsOfUseComponent;
